import { useTemplatesContext } from '../components/Templates/TemplatesContext';
export const usePageLoading = () => {
  const {
    isPageLoading,
    setIsPageLoading
  } = useTemplatesContext();
  return [isPageLoading, setIsPageLoading];
};
//# sourceMappingURL=usePageLoading.js.map